module.exports = __webpack_public_path__ + "static/media/card_mastercard.e83878d0.svg";